import { Component, inject, input, output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { COMMON_IMPORTS } from '../../../../../../Shared/common-imports';
import { AvTableLoadingBarComponent } from '../../../../../../Shared/Components/loading-bar/table-loading-bar.component';
import { BillingInvoice } from '../../../../../../../Interfaces/api/billing.interface';
import { BILLING_INVOICE_COLUMNS, BILLING_STATUS_CLASSES } from '../../../../../../../Consts/billing.const';

@Component({
    selector: 'app-billing-invoices-card',
    standalone: true,
    imports: [COMMON_IMPORTS, AvTableLoadingBarComponent],
    templateUrl: './invoices-card.component.html',
    styleUrls: [
        '../../billing.scss',
        '../../../../../../../../assets/theme/cutom/_av-table.scss',
        './invoices-card.component.scss',
    ],
})
export class BillingInvoicesCardComponent {
    private readonly _translate = inject(TranslateService);

    readonly invoices = input<BillingInvoice[]>([]);
    readonly count = input<number>(0);
    readonly pageIndex = input<number>(0);
    readonly pageSize = input<number>(10);
    readonly isReadOnly = input<boolean>(false);
    readonly isLoading = input<boolean>(false);

    readonly pageChange = output<number>();
    readonly reload = output<void>();

    readonly displayedColumns = BILLING_INVOICE_COLUMNS;

    statusClass(invoice: BillingInvoice): string {
        return BILLING_STATUS_CLASSES[invoice.display_status] ?? 'open';
    }

    statusKey(invoice: BillingInvoice): string {
        return `app.billing.invoices.display_statuses.${this.statusClass(invoice)}`;
    }

    tooltip(invoice: BillingInvoice): string {
        const reason = invoice.latest_payment?.failure_message ?? '';
        const attempts = invoice.attempt_count;

        if (reason && attempts > 1) {
            return this._translate.instant('app.billing.invoices.failure_with_attempts', { reason, count: attempts });
        }

        if (reason) {
            return reason;
        }

        if (attempts > 1) {
            return this._translate.instant('app.billing.invoices.attempts', { count: attempts });
        }

        return '';
    }

    onPage(event: PageEvent): void {
        this.pageChange.emit(event.pageIndex);
    }
}
